import { lazy } from 'react';
import { useRoutePayload, Redirect, Router } from '@calvear/react-spa-routerizer';
import { AuthenticationService, useAuthenticationState } from 'modules/security';
import Loader from 'modules/ui/components/loader';
import { useAuthState, AuthService } from '../layouts/app/authService';

// const config = {
//     clientId: process.env.REACT_APP_AAD_CLIENT_ID,
//     tenantId: process.env.REACT_APP_AAD_TENANT_ID,
//     loginActionRedirect: process.env.REACT_APP_AAD_LOGIN_ACTION_REDIRECT,
//     logoutActionRedirect: process.env.REACT_APP_AAD_LOGOUT_ACTION_REDIRECT,
//     tokenRefreshUri: process.env.REACT_APP_AAD_TOKEN_REFRESH_URI,
// };

// initializes Microsoft Active Directory authentication service.
// AuthenticationService.init(config, process.env.REACT_APP_AAD_ENABLED !== 'true');

AuthService.init();

// not found page for default route.
const DefaultPage = lazy(() => import('pages/not-found'));

/**
 * Application main routing handler.
 *
 * @returns {React.ReactElement} Application main router.
 */
export default function AppRouter() {
    const { secured } = useRoutePayload();
    // const { authenticated, authenticating, error } = useAuthenticationState();
    const { authenticated, authenticating, error } = useAuthState();

    if (!secured && authenticated) return <Redirect to='/' />;

    if (secured && !authenticated) {
        if (authenticating) return <Loader message='Autenticando' />;

        if (error) return <Redirect to='/403' />;

        return <Redirect to='/login' />;
    }

    return <Router loader={<Loader message='Cargando' />} DefaultChild={DefaultPage} />;
}
